/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_What_TitleInputs */

const en_fw_guide_what_title = /** @type {(inputs: Fw_Guide_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Firefly Wedding?`)
};

const zh_fw_guide_what_title = /** @type {(inputs: Fw_Guide_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁是什么作品？`)
};

/**
* | output |
* | --- |
* | "What is Firefly Wedding?" |
*
* @param {Fw_Guide_What_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_what_title = /** @type {((inputs?: Fw_Guide_What_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_What_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_what_title(inputs)
	return zh_fw_guide_what_title(inputs)
});
export { fw_guide_what_title as "fw.guide.what.title" }